module.exports = __webpack_public_path__ + "static/img/bannerVuewjs.d9b041c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bannerVuewjs.jpg
// module id = TGt5
// module chunks = 1